import { Box, styled } from '@mui/joy'

export const Wrapper = styled(Box)`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .MuiAvatar-root {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
`
